import { Link } from "react-router-dom";
import { MapPin, BadgeCheck, Car } from "lucide-react";
import { imgUrl } from "../lib/api";
import DealerLogo from "./DealerLogo";

export default function DealerCard({ dealer }) {
  return (
    <Link to={`/dealers/${dealer.id}`} data-testid={`dealer-card-${dealer.id}`} className="group lux-card overflow-hidden block hover:border-[#D4AF37]/60 transition-[border-color,transform] duration-300 hover:-translate-y-1">
      <div className="relative h-28 overflow-hidden">
        {dealer.banner_url ? <img src={imgUrl(dealer.banner_url)} alt="" className="w-full h-full object-cover opacity-70 group-hover:scale-105 transition-transform duration-700" /> : <div className="w-full h-full bg-[radial-gradient(ellipse_at_top,rgba(212,175,55,0.25),transparent)]" />}
        <div className="absolute inset-0 bg-gradient-to-t from-[#161922] to-transparent" />
        {dealer.is_demo && <span className="absolute top-2 right-2 text-[10px] uppercase bg-black/70 text-gray-300 px-2 py-0.5 rounded-full">Demo</span>}
      </div>
      <div className="px-5 pb-5 -mt-8 relative space-y-3">
        <DealerLogo dealer={dealer} />
        <div>
          <h3 className="font-semibold text-white flex items-center gap-1.5">{dealer.name}{dealer.verified && <BadgeCheck className="w-4 h-4 text-[#D4AF37]" data-testid="verified-badge" />}</h3>
          <p className="text-xs text-gray-400 flex items-center gap-1 mt-1"><MapPin className="w-3 h-3 text-[#D4AF37]" />{dealer.city}, {dealer.state}</p>
        </div>
        <p className="text-xs text-[#E5C158] flex items-center gap-1.5"><Car className="w-3.5 h-3.5" />{dealer.inventory ?? 0} cars in stock</p>
      </div>
    </Link>
  );
}
